import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entries", "pagination"]
  static values = {
    page: { type: Number, default: 1 },
    loading: { type: Boolean, default: false }
  }

  connect() {
    console.log("Infinite scroll controller connected")
    this.scroll = this.scroll.bind(this)
    window.addEventListener("scroll", this.scroll)
  }

  disconnect() {
    window.removeEventListener("scroll", this.scroll)
  }

  scroll() {
    if (this.loadingValue) {
      console.log("Already loading, skipping...")
      return
    }

    const nextPage = this.paginationTarget.querySelector("a[rel='next']")
    if (!nextPage) {
      console.log("No next page link found")
      return
    }

    const scrollBottom = window.scrollY + window.innerHeight
    const documentHeight = document.documentElement.scrollHeight
    const threshold = 500 // Load when 500px from bottom

    console.log("Scroll position:", scrollBottom, "Document height:", documentHeight)

    if (scrollBottom >= documentHeight - threshold) {
      console.log("Near bottom! Loading more from:", nextPage.href)
      this.loadMore(nextPage.href)
    }
  }

  loadMore(url) {
    if (this.loadingValue) return

    this.loadingValue = true
    console.log("Loading more results from:", url)

    // Show loading indicator
    this.showLoadingIndicator()

    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => {
        console.log("Response received:", response.status, response.statusText)
        return response.text()
      })
      .then(html => {
        console.log("HTML received, length:", html.length)
        console.log("First 500 chars:", html.substring(0, 500))

        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")

        // Debug: log what we got
        console.log("Parsed document:", doc)
        console.log("Document body:", doc.body?.innerHTML.substring(0, 200))

        // Append new entries
        const newEntries = doc.querySelector("#courses-grid")
        console.log("Looking for #courses-grid...")
        console.log("New entries element found:", !!newEntries)
        console.log("Entries target exists:", this.hasEntriesTarget)

        if (newEntries && this.hasEntriesTarget) {
          const newCards = newEntries.children
          console.log("Found", newCards.length, "new cards to append")
          console.log("Current entries count:", this.entriesTarget.children.length)

          Array.from(newCards).forEach((card, index) => {
            console.log(`Appending card ${index + 1}`)
            this.entriesTarget.appendChild(card.cloneNode(true))
          })

          console.log("Cards appended! New count:", this.entriesTarget.children.length)
        } else {
          console.error("Could not find new entries or entries target")
          console.error("newEntries:", newEntries)
          console.error("hasEntriesTarget:", this.hasEntriesTarget)
        }

        // Update pagination links
        const newPagination = doc.querySelector("[data-infinite-scroll-target='pagination']")
        console.log("New pagination found:", !!newPagination)

        if (newPagination && this.hasPaginationTarget) {
          this.paginationTarget.innerHTML = newPagination.innerHTML
          console.log("Pagination updated")
        } else {
          console.error("Could not update pagination")
        }

        // Hide loading indicator
        this.hideLoadingIndicator()
        this.loadingValue = false
        console.log("Loading complete!")
      })
      .catch(error => {
        console.error("Error loading more results:", error)
        this.hideLoadingIndicator()
        this.loadingValue = false
      })
  }

  showLoadingIndicator() {
    const loadingEl = document.getElementById('infinite-scroll-loading')
    if (loadingEl) {
      loadingEl.classList.remove('hidden')
    }
  }

  hideLoadingIndicator() {
    const loadingEl = document.getElementById('infinite-scroll-loading')
    if (loadingEl) {
      loadingEl.classList.add('hidden')
    }
  }
}
